// Apolo IDE — responsive device presets for the preview pane (E2).
// Pure data; no imports so it stays trivially testable.

export const DEVICE_PRESETS = {
  responsive: { label: 'Responsivo', icon: 'Maximize2', width: null, height: null, dpr: 1 },
  desktop: { label: 'Desktop', icon: 'Monitor', width: 1280, height: 800, dpr: 1 },
  tablet: { label: 'Tablet', icon: 'Tablet', width: 768, height: 1024, dpr: 2 },
  mobile: { label: 'Mobile', icon: 'Smartphone', width: 390, height: 844, dpr: 3 },
};

export const DEVICE_ORDER = ['responsive', 'desktop', 'tablet', 'mobile'];

export function getDevice(key) {
  return DEVICE_PRESETS[key] || DEVICE_PRESETS.responsive;
}
